// extracted by mini-css-extract-plugin
export default {"graphColor":"#e0ecec","lineColor":"#001e62","fontColor":"#838ca3","fontSize":"14px","graph":"style--graph--832fae","graphContainer":"style--graphContainer--713e47"};